import React, { FC, useState } from 'react';
import styled from 'styled-components';

import AnimatedCaret from '@ui/atoms/AnimatedCaret';
import Skeleton from '@ui/atoms/Skeleton';

import useFetchPhoto from '@hooks/useFetchPhoto';

import theme from '@theme/FolxTheme';

interface IProfileButtonProps {
	open: boolean;
	handleClick?: () => void;
	className?: string;
}

const StyledProfile = styled.button`
	display: flex;
	align-items: center;
	border: 0;
	margin: 0;
	padding: 0;
	margin: 0;
	background: transparent;
	cursor: pointer;
`;

const StyledSelfie = styled.div<{ placeholder: boolean }>`
	align-items: center;
	background-color: ${theme.colors.lightGray};
	border-radius: 50%;
	display: flex;
	height: ${theme.spacing.lgxl};
	justify-content: center;
	margin-right: 1.2rem;
	overflow: hidden;
	width: ${theme.spacing.lgxl};

	img {
		object-fit: cover;
		height: ${({ placeholder }) => (placeholder ? theme.spacing.lg : '100%')};
		width: ${({ placeholder }) => (placeholder ? theme.spacing.lg : '100%')};
	}
`;

const ProfileButton: FC<IProfileButtonProps> = ({ className, handleClick = () => {}, open }) => {
	const [placeholder, setPlaceholder] = useState<boolean>(false);

	const isPlaceholder = (isPlaceholder: boolean) => {
		setPlaceholder(isPlaceholder);
	};

	const { photo: selfie } = useFetchPhoto({
		imageType: 'Selfie',
		handleError: () => isPlaceholder(true),
		callback: () => isPlaceholder(false),
	});

	return (
		<StyledProfile
			aria-label="More Options"
			className={className}
			type="button"
			onClick={() => {
				handleClick();
			}}>
			<StyledSelfie placeholder={placeholder}>
				{selfie ? (
					<img src={selfie} alt="a picture of you" />
				) : (
					<Skeleton borderRadius="half" height="lgxl" />
				)}
			</StyledSelfie>
			<AnimatedCaret open={open} />
		</StyledProfile>
	);
};

export default styled(ProfileButton)``;
